var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"px-0",attrs:{"cols":"12"}},[_c('v-row',{staticClass:"mx-0"},[(_vm.singleRFP.details)?_c('p',{staticClass:"body-1",staticStyle:{"max-width":"260px"}},[_vm._v(_vm._s(_vm.singleRFP.details))]):_c('p',{staticClass:"subtitle-1 platinum--text text--darken-3"},[_vm._v("No remarks given")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }